<template>
  <div class="modal_edit_profile">
    <div class="header">
      <span class="btn not_visible "></span>
      <h4 class="title">
        {{ translate("device.main_info") }} {{ profile.fid }}({{ profile.name2 }})
      </h4>
      <span
          v-if="$store.getters.getPermissions.permissionGod === true"
          class="btn btn-info btn-fill"
          @click.prevent="info_cleansing"
      >
        {{ translate("btn.clear") }}
      </span>
    </div>
    <div class="line">
      <div class="elem" v-if="client_info.client">
        <fg-input
            autocomplete="phone"
            v-model="client_name"
            :type="'tel'"
            :label="translate('client.one')"
            :placeholder="translate('client.one')"
            :disabled="true"
        />
      </div>
      <div class="elem">
        <label> {{ translate("group.one") }} </label>
        <tree-select
            v-model="profile.group_id"
            :options="opt_groups"
            :placeholder="translate('groups')"
            track-by="name"
            :clearable="false"
            :noresult="translate('group.not_found')"
        />
      </div>
    </div>

    <div class="line">
      <div class="elem" style="position: relative">
        <fg-input
            v-model="$v.profile.name2.$model"
            type="text"
            :label="translate('device.name')"
            :placeholder="translate('device.name')"
        />
        <small
            class="red-text"
            v-if="$v.profile.name2.$dirty && !$v.profile.name2.maxLength"
        >{{ translate("device.validate.max_char") }} 64</small
        >
      </div>
    </div>

    <div class="" style="position: relative" v-if="client_info?.service_name && client_info?.service_name !== ''">
      <fg-input
          v-model="$v.profile.service_id.$model"
          type="text"
          :label="client_info.service_name"
          :placeholder="client_info.service_name"
      />
      <small
          class="red-text"
          v-if="$v.profile.service_id.$dirty && !$v.profile.service_id.maxLength"
      >{{ translate("device.validate.max_char") }} 64</small
      >
    </div>

    <div
      class=""
      style="position: relative"
      v-if="$store.getters.getPermissions.permissionGod === true"
    >
      <fg-input
        v-model="$v.profile.name.$model"
        type="text"
        :label="translate('device.hidden_name')"
        :placeholder="translate('device.hidden_name')"
      />
      <small
        class="red-text"
        v-if="$v.profile.name.$dirty && !$v.profile.name.maxLength"
        >{{ translate("device.validate.max_char") }} 50</small
      >
    </div>
    <div class="" style="position: relative">
      <fg-input
        v-model="$v.profile.place.$model"
        type="text"
        :label="translate('device.place')"
        :placeholder="translate('device.place')"
      />
      <small
        class="red-text"
        v-if="$v.profile.place.$dirty && !$v.profile.place.maxLength"
        >{{ translate("device.validate.max_char") }} 64</small
      >
    </div>
    <div class="" style="position: relative">
      <fg-input
        v-model="profile.place_full"
        type="text"
        :label="translate('device.place_full')"
        :placeholder="translate('device.place_full')"
      />
      <small
          class="red-text"
          v-if="$v.profile.place_full.$dirty && !$v.profile.place_full.maxLength"
      >{{ translate("device.validate.max_char") }} 128</small
      >
    </div>
    <div class="" style="position: relative">
      <fg-input
        v-model="$v.profile.desc.$model"
        type="text"
        :label="translate('device.desc')"
        :placeholder="translate('device.desc')"
      />
      <small
        class="red-text"
        v-if="$v.profile.desc.$dirty && !$v.profile.desc.maxLength"
        >{{ translate("device.validate.max_char") }} 64</small
      >
    </div>
    <div class="">
      <div class="form-group">
        <label>{{ translate("device.desc_add") }}</label>
        <textarea
          v-model="profile.add_desc"
          rows="3"
          class="form-control border-input"
          :placeholder="translate('device.desc_add')"
        />
      </div>
    </div>
    <div class="text-center">
      <button
        v-if="group_change"
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="preUpdateDevice()"
      >
        {{ translate("device.config.accept_yes") }}
      </button>

      <span
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="updateDevice(false)"
      >
        {{ translate("save") }}
      </span>

      <span
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate("close_modal") }}
      </span>
    </div>
  </div>
</template>
<script>
import { maxLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm";

export default {
  name: "EditDeviceProfile",
  props: ["device", "client_info", "vlan"],
  mixins: [validationMixin],

  data() {
    return {
      acceptConf: false,
      profile: {},
    };
  },
  validations() {
    return {
      profile: {
        name2: {
          maxLength: maxLength(64),
        },
        name: {
          maxLength: maxLength(50),
        },
        place: {
          maxLength: maxLength(64),
        },
        place_full: {
          maxLength: maxLength(128),
        },
        desc: {
          maxLength: maxLength(64),
        },
        service_id:{
          maxLength: maxLength(32),
        }
      },
    };
  },
  created() {
    this.profile = { ...this.device.user_info, vlan: this.vlan};
    this.client_info.service_name && this.client_info.service_name !== "" ? this.profile.service_id = this.client_info.service_id : ""
  },
  computed: {
    group_change() {
      return +this.device.group_id !== +this.profile.group_id;
    },
    opt_groups() {
      return this.$store.getters.getDeviceGroupsTree;
    },
    client_name() {
      return this.client_info.client.client_name;
    },
  },
  methods: {
    info_cleansing(){
      this.profile.name2 = "Деактивирован"
      this.profile.name = ""
      this.profile.place = ""
      this.profile.place_full = ""
      this.profile.desc = ""
      this.profile.add_desc = ""
    },
    cancel() {
      this.$emit("close");
    },
    preUpdateDevice(){
      const group = this.$store.getters.getDeviceGroupById(this.profile.group_id)
      const group_name = document.createElement('strong')
      group_name.textContent = group.name
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('device.config.ask_confirm', {group: group_name.outerHTML})
        },
        on: {
          close: () => {
            this.$modal.hide('device_ask_confirm')
          },
          confirm: () => {
            this.updateDevice(true)
            this.$modal.hide('device_ask_confirm')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'device_ask_confirm'
      })
    },
    updateDevice(change) {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      } else {
        if (change) {
          this.acceptConf = true;
        }
        this.profile.vlan = this.profile.vlan !== null && this.profile.vlan !== "" ? Number(this.profile.vlan) : null
        const params = {
          ...this.profile,
          id: this.device.id,
          acceptConf: this.acceptConf
        }
        this.$http.v1.saveDeviceProfile( this.device.fid, params, (response) => {
          let text = this.translate("profile_saved")
          if (response.data.apply_group_config) {
            const group = this.$store.getters.getDeviceGroupById(this.device.user_info.group_id)
            text += `<br>${this.translate("device.config.group_config")} "${group.name}" ${this.translate("device.config.successfully_applied")}`
          }
          this.global_notify("info", text);
          this.$store.dispatch("delete_link_device", {
            group: this.device.user_info.group_id,
            id: this.device.fid,
          });
          let device = {...this.device, user_info: this.profile}
          this.$store.commit("updateDeviceProfile", device);
          this.$store.commit("setDeviceListChange", true);
          this.$emit("update");
        });
      }
    },
  },
};
</script>

<style lang='scss'>
.modal_edit_profile {
  padding: 10px;
  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn{
      width: 100px;
      &.not_visible{
        opacity: 0;
      }
    }
    .title{
      margin: 10px 0;
    }
  }
  .line{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    @media (max-width:768px) {
      flex-direction: column;
    }
    .elem{
      width: 100%;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
      .vue-treeselect{
        margin-bottom: 10px;
      }
    }
    .vlan{
      width: 25%;
    }
    .red-text{
      left: 0;
      bottom: -6px;
    }
  }
}
.marginButton {
  margin: 5px;
}
.v-spinner {
  margin-bottom: 10px;
}
.tdFont {
  font-weight: bold;
}
.block {
  text-align: right;
}
</style>
